<template>
  <div id="trame" :class="{ 'trame-embedded': embedded }">

    <!-- HEADER CARD -->
    <div class="trame-header-card">
      <div class="trame-meta">
        <div class="trame-title">{{ trame }}</div>
      </div>
      <button class="btn btn-secondary btn-sm" @click="goToPlanning()" v-if="!embedded">
        ← Retourner au planning
      </button>
    </div>

    <!-- CARROUSEL NAV -->
    <div class="section-nav">
      <button class="nav-arrow-btn" @click="subCarrousel">&#8249;</button>
      <div class="section-title">{{ this.titleCarrousel }}</div>
      <button class="nav-arrow-btn" @click="addCarrousel">&#8250;</button>
    </div>

    <!-- LÉGENDE -->
    <div class="legend-bar">
      <span class="legend-label">Légende :</span>
      <span class="legend-dot">
        <span class="legend-pip pip-amber"></span>
        <span class="pip-text amber">Débuté</span>
      </span>
      <span class="legend-dot">
        <span class="legend-pip pip-blue"></span>
        <span class="pip-text blue">Assimilé</span>
      </span>
      <span class="legend-dot">
        <span class="legend-pip pip-green"></span>
        <span class="pip-text green">Parfaitement assimilé</span>
      </span>
    </div>

    <!-- SYNTHESE GRID — donuts -->
    <div class="synthese-grid" v-if="this.compSelec.length === 0 && this.$store.state.rdvStart != true">
      <div
        class="competence-item-wrap"
        v-for="(competence, index) in competences"
        :key="index"
      >
        <div class="competence-label-top">{{ competence.nom }}</div>
        <div class="competence-card" @click="getCompetence(competence)">
          <div class="competence-progress-row">
            <div class="competence-progress-bar">
              <div
                class="competence-progress-fill"
                :style="{ width: competence.pourcent + '%', background: donutColor(competence.pourcent) }"
              ></div>
            </div>
            <span class="competence-progress-label" :style="{ color: donutColor(competence.pourcent) }">{{ competence.pourcent }}%</span>
          </div>
          <div class="donut-wrap">
            <svg viewBox="0 0 36 36">
              <circle cx="18" cy="18" r="15.9155" fill="none" stroke="#f1f5f9" stroke-width="3.5"/>
              <circle
                cx="18" cy="18" r="15.9155" fill="none"
                :stroke="donutColor(competence.pourcent)"
                stroke-width="3.5"
                :stroke-dasharray="competence.pourcent + ' ' + (100 - competence.pourcent)"
                stroke-linecap="round"
              />
            </svg>
            <div class="donut-center" :style="{ color: donutColor(competence.pourcent) }">
              {{ competence.heuresAFaire != null ? formatMinutes(competence.heuresAFaire) : competence.pourcent + '%' }}
            </div>
          </div>
          <span class="competence-heures" v-if="competence.heuresAFaire != null">{{ formatMinutes(competence.heuresAFaire) }} pour compléter cette compétence</span>
        </div>
      </div>
    </div>

    <!-- COMPETENCE DETAIL -->
    <div class="competence-detail" v-if="this.compSelec.length != 0">
      <template v-for="(obj, i) in compSelec.objs" :key="i">
        <div class="competence-section">
          <div class="competence-section-header">
            <div
              class="competence-section-check"
              :class="{
                'check-full':    obj.fait >= obj.tot,
                'check-partial': obj.fait >= obj.tot / 3 && obj.fait < obj.tot,
                'check-empty':   obj.fait < obj.tot / 3
              }"
            >
              <svg v-if="obj.fait >= obj.tot" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>
              <span v-else-if="obj.fait >= obj.tot / 3">~</span>
            </div>
            <div class="competence-section-title">{{ obj.label }}</div>
            <span class="duree-restante" v-if="obj.dureeRestante != null">{{ obj.dureeRestante }} min restantes</span>
          </div>

          <div class="competence-items">
            <div class="competence-item" v-for="(ssobj, index) in obj.ssobjs" :key="index">
              <div
                class="status-pip"
                :class="{
                  'pip-status-amber': ssobj.status === 1,
                  'pip-status-blue':  ssobj.status === 2,
                  'pip-status-green': ssobj.status === 3,
                  'pip-status-empty': ssobj.status === 0
                }"
                :data-status="ssobj.status"
                data-type="ssobj"
                :data-id="ssobj.id"
                :data-idComp="this.compSelec.id"
              ></div>
              <span class="item-label">{{ ssobj.label }}</span>
              <span class="duree-restante" v-if="ssobj.dureeRestante != null && !isEleveViewer">{{ ssobj.dureeRestante }} min restantes</span>
            </div>
          </div>
        </div>
      </template>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    eleveId: {
      type: [String, Number],
      default: null,
    },
    embedded: {
      type: Boolean,
      default: false,
    },
    viewerIsEleve: {
      type: Boolean,
      default: null,
    },
  },

  data() {
    return {
      trame: "",
      competences: [],
      titleCarrousel: "SYNTHESE",
      compSelec: [],
      index: null,
    };
  },

  computed: {
    resolvedId() {
      return this.eleveId != null ? this.eleveId : this.$route.params.id;
    },
    isEleveViewer() {
      if (this.viewerIsEleve !== null) return this.viewerIsEleve;
      return this.$route.params.return === "eleve";
    },
  },

  mounted() {
    this.getTrame();
  },

  methods: {
    formatMinutes(minutes) {
      const h = Math.floor(minutes / 60);
      const m = minutes % 60;
      return m === 0 ? h + "h" : h + "h" + String(m).padStart(2, "0");
    },

    donutColor(pourcent) {
      if (pourcent >= 100) return "#22c55e";
      if (pourcent >= 50)  return "#3b82f6";
      if (pourcent >= 1)   return "#f59e0b";
      return "#ef4444";
    },

    goToPlanning() {
      if (this.$route.params.return == "eleve") {
        this.$router.push({ name: "eleve_conduite" });
      } else {
        this.$router.push({ name: "agence-planning" });
      }
    },

    subCarrousel() {
      if (this.index == 0) {
        this.index = null;
        this.compSelec = [];
        this.titleCarrousel = "SYNTHESE";
      } else {
        this.index = this.index === null ? this.competences.length - 1 : this.index - 1;
        window.api.get("/competence/" + this.resolvedId + "/" + this.index, {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        }).then(response => {
          this.compSelec = response.data.comp[0];
          this.titleCarrousel = this.compSelec.label;
        }).catch(error => { console.log(error); });
      }
    },

    addCarrousel() {
      if (this.index == this.competences.length - 1) {
        this.index = null;
        this.compSelec = [];
        this.titleCarrousel = "SYNTHESE";
      } else {
        this.index = this.index === null ? 0 : this.index + 1;
        window.api.get("/competence/" + this.resolvedId + "/" + this.index, {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        }).then(response => {
          this.compSelec = response.data.comp[0];
          this.titleCarrousel = this.compSelec.label;
        }).catch(error => { console.log(error); });
      }
    },

    getCompetence(comp) {
      window.api.get("/competence/" + this.resolvedId + "/" + comp.index, {
        headers: { Authorization: "Bearer " + this.$store.state.token },
      }).then(response => {
        this.index = comp.index;
        this.compSelec = response.data.comp[0];
        this.titleCarrousel = this.compSelec.label;
      }).catch(error => { console.log(error); });
    },

    getTrame() {
      window.api.get("/trame/eleve/" + this.resolvedId, {
        headers: { Authorization: "Bearer " + this.$store.state.token },
      }).then(response => {
        this.trame = response.data.trame;
        this.competences = response.data.comp;
      }).catch(error => { console.log(error); });
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;1,9..40,400&display=swap');

*, *::before, *::after { box-sizing: border-box; }

#trame {
  background: #f4f6f9;
  min-height: 100vh;
  padding: 24px;
  font-family: 'DM Sans', system-ui, sans-serif;
  color: #1a1f2e;
}

#trame.trame-embedded {
  min-height: 0;
  padding: 0;
  background: transparent;
}

/* HEADER */
.trame-header-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 20px 24px;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0,0,0,.06);
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
}

.trame-title {
  font-size: 20px;
  font-weight: 600;
  letter-spacing: -.3px;
}

/* BUTTONS */
.btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all .15s;
  white-space: nowrap;
}
.btn-secondary { background: #f4f6f9; color: #64748b; border: 1px solid #e2e8f0; }
.btn-secondary:hover { background: #fff; color: #1a1f2e; }
.btn-sm { padding: 5px 11px; font-size: 11px; border-radius: 8px; }

/* SECTION NAV */
.section-nav {
  display: flex;
  align-items: center;
  gap: 16px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 12px 16px;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0,0,0,.06);
}

.nav-arrow-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  font-size: 18px;
  transition: all .12s;
  flex-shrink: 0;
}
.nav-arrow-btn:hover { background: #f4f6f9; color: #1a1f2e; border-color: #94a3b8; }

.section-title {
  flex: 1;
  text-align: center;
  font-size: 18px;
  letter-spacing: -.3px;
}

/* LÉGENDE */
.legend-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #64748b;
  flex-wrap: wrap;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 10px 16px;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0,0,0,.06);
}
.legend-label { font-weight: 600; }
.legend-dot { display: inline-flex; align-items: center; gap: 5px; }
.legend-pip { display: inline-block; width: 10px; height: 10px; border-radius: 3px; }
.pip-amber { background: #f59e0b; }
.pip-blue  { background: #3b82f6; }
.pip-green { background: #1a9e6e; }
.pip-text.amber { color: #f59e0b; font-weight: 600; }
.pip-text.blue  { color: #3b82f6; font-weight: 600; }
.pip-text.green { color: #1a9e6e; font-weight: 600; }

/* SYNTHESE GRID */
.synthese-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.competence-item-wrap {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.competence-label-top {
  text-align: center;
  font-size: 12px;
  font-weight: 700;
  color: #1a1f2e;
  line-height: 1.4;
}

.competence-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0,0,0,.06);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  cursor: pointer;
  transition: box-shadow .15s, transform .15s;
}
.competence-card:hover { box-shadow: 0 4px 16px rgba(0,0,0,.08); transform: translateY(-2px); }

.competence-progress-row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}
.competence-progress-bar {
  flex: 1;
  height: 8px;
  background: #f1f5f9;
  border-radius: 999px;
  overflow: hidden;
}
.competence-progress-fill {
  height: 100%;
  border-radius: 999px;
  transition: width .2s;
}
.competence-progress-label {
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

.donut-wrap {
  position: relative;
  width: 90px;
  height: 90px;
}
.donut-wrap svg {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}
.donut-center {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
}

.competence-heures {
  font-size: 12px;
  font-weight: 700;
  color: #ef4444;
}

/* COMPETENCE DETAIL */
.competence-detail { display: flex; flex-direction: column; gap: 20px; margin-bottom: 24px; }

.competence-section-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.competence-section-check {
  width: 22px;
  height: 22px;
  border-radius: 6px;
  border: 2px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  flex-shrink: 0;
}
.check-full    { background: #1a9e6e; border-color: #1a9e6e; color: #fff; }
.check-partial { background: #f59e0b; border-color: #f59e0b; color: #fff; }
.check-empty   { background: #fff; color: transparent; }

.competence-section-title { font-size: 14px; font-weight: 700; color: #1a1f2e; }

.competence-items { display: flex; flex-direction: column; gap: 8px; padding-left: 32px; }

.competence-item {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px 14px;
  box-shadow: 0 1px 3px rgba(0,0,0,.06);
}

.status-pip {
  width: 14px;
  height: 14px;
  border-radius: 4px;
  flex-shrink: 0;
}
.pip-status-empty { background: #f1f5f9; border: 1px solid #e2e8f0; }
.pip-status-amber { background: #f59e0b; }
.pip-status-blue  { background: #3b82f6; }
.pip-status-green { background: #1a9e6e; }

.item-label { font-size: 13px; color: #64748b; }

.duree-restante {
  font-size: 11px;
  font-weight: 600;
  color: #94a3b8;
  margin-left: auto;
  white-space: nowrap;
}
</style>